<template>
    <section>
        <base-card>
            <h2>코치로 등록!</h2>
            <coach-form @save-data="saveData"></coach-form>
        </base-card>
    </section>
</template>

<script>
import CoachForm from '@/components/coaches/CoachForm.vue'
export default {
    components:{
        CoachForm
    },
    methods:{
        saveData(data){
            this.$store.dispatch('coaches/registerCoach', data)
            //this.$router.push('/main/coaches')
            this.$router.replace('/main/coaches')
        }
    }
}
</script>

<style>

</style>
